export default __webpack_public_path__ + "static/media/ev_car.401c45c0.jpg";